export default "__VITE_ASSET__Co2DSLf3__"